(() => {
  const form = document.getElementById('ncz-header-language');
  if (!form) return;
  const select = form.querySelector('[name="language_code"]');
  if (!select) return;
  const supported = [...select.options].map(option => option.value);
  let manuallySelected = false;
  const remember = language => {
    try { localStorage.setItem('ncz-language-choice', language); } catch {}
  };
  const submit = language => {
    if (!supported.includes(language)) return;
    select.value = language;
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    form.requestSubmit();
  };
  select.addEventListener('change', () => {
    manuallySelected = true;
    remember(select.value);
    submit(select.value);
  });
  form.addEventListener('submit', () => {
    manuallySelected = true;
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
    remember(select.value);
  });
  if (window.Shopify?.designMode) return;
  const current = document.documentElement.lang.split('-')[0];
  if (current !== 'en') return;
  let choice;
  try { choice = localStorage.getItem('ncz-language-choice'); } catch {}
  if (choice && supported.includes(choice)) {
    if (choice !== current) submit(choice);
    return;
  }
  try {
    if (sessionStorage.getItem('ncz-language-detected')) return;
    sessionStorage.setItem('ncz-language-detected', '1');
  } catch {}
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {signal: AbortSignal.timeout(4000)})
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      if (manuallySelected) return;
      const country = data?.detected_values?.country?.handle;
      if (!country) return;
      const language = ({CZ:'cs',DE:'de',AT:'de',SE:'sv',RO:'ro'})[country] || 'en';
      if (language !== current && supported.includes(language)) submit(language);
    })
    .catch(() => {});
})();
